import { render, staticRenderFns } from "./GuestbookTable.vue?vue&type=template&id=551a3376&scoped=true"
import script from "./GuestbookTable.vue?vue&type=script&lang=js"
export * from "./GuestbookTable.vue?vue&type=script&lang=js"
import style0 from "./GuestbookTable.vue?vue&type=style&index=0&id=551a3376&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551a3376",
  null
  
)

export default component.exports